package com.milta.core.localization.translations.bg

import com.milta.core.localization.AdminOcrAnalysisStrings

internal val AdminOcrAnalysis = AdminOcrAnalysisStrings(
    loading = "Зареждане…",
    errorNoConnection = "Сървърът не може да бъде достигнат — провери връзката си.",
    errorGeneric = "Възникна грешка. Опитай отново по-късно.",
    emptyStateMessage = "Все още няма данни.",
    kpiTotalDocumentsLabel = "Анализирани документи",
    kpiCompletedDocumentsLabel = "Завършени документи",
    kpiCompletedDocumentsSubtitle = "симулирани за 4-те стратегии",
    kpiTotalRealCostLabel = "Обща реална цена",
    kpiTotalInputTokensLabel = "Входни токени",
    kpiTotalOutputTokensLabel = "Изходни токени",
    breakdownByFileKindLabel = "Разбивка",
    fileKindImageLabel = "Изображения",
    fileKindPdfLabel = "PDF файлове",
    fileKindXlsxLabel = "Таблици",
    flowTitle = "Пълният процес, стъпка по стъпка",
    flowYesLabel = "Да",
    flowNoLabel = "Не",
    flowStep1Title = "Изпратен документ",
    flowStep1Subtitle = "Снимка, PDF или файл, получен чрез приложението",
    flowStep2Title = "Изчислен уникален отпечатък",
    flowStep2Subtitle = "Изчислява се уникален идентификатор за този документ",
    flowStep2Note = "Ако вече е видян: локалният анализ не се прави отново (реалната цена на ИИ продължава да се брои нормално, тъй като е реално качване).",
    flowStep3Title = "Открит тип файл",
    flowStep3Subtitle = "Останалата част от анализа се различава според типа",
    flowImageBranchTitle = "📷 Ако е снимка",
    flowImageStep1Title = "Проверка на качеството",
    flowImageStep1Subtitle = "Яснота, яркост, резолюция, добре кадриран документ",
    flowImageStep2Title = "Ако качеството се счете за недостатъчно",
    flowImageStep2Subtitle = "Причината се записва, но локалното четене все пак се опитва веднага след това",
    flowImageStep3Title = "Коригиране на наклона",
    flowImageStep3Subtitle = "Изображението се изправя, ако се открие надежден наклон",
    flowImageStep4Title = "Локално четене (безплатно)",
    flowImageStep4Subtitle = "Четене на текста без ИИ — френски, нидерландски, английски",
    flowImageStep5Title = "Оценка за надеждност",
    flowImageStep5Subtitle = "Оценка от 0 до 100 за качеството на това локално четене",
    flowPdfBranchTitle = "📄 Ако е PDF",
    flowPdfStep1Title = "Открит ли е нативен текст?",
    flowPdfStep1Subtitle = "Проверява дали PDF файлът вече съдържа използваем цифров текст",
    flowPdfNote = "Ако е сканиран без нативен текст: всяка страница (до 20) се преобразува в изображение и се прочита отново локално, както снимка.",
    flowXlsxBranchTitle = "📊 Ако е таблица",
    flowXlsxStep1Title = "Разпознати колони",
    flowXlsxStep1Subtitle = "Автоматично, или с помощта на ИИ, разпознаване на колони (име, адрес, телефон…)",
    flowXlsxNote = "Структурата на файла (редове, колони, заглавие) се анализира локално.",
    flowClaudeTitle = "Извикване на ИИ (Claude)",
    flowClaudeSubtitle = "Днес винаги се прави реално извикване, независимо от пътя по-горе — начислена реална цена",
    flowSimulationTitle = "🔬 Симулация впоследствие (не в продукция)",
    flowSimulationNote = "След като горните данни бъдат събрани, 4 алтернативни стратегии се пресъздават върху същите документи, за да се прецени какво биха стрували вместо систематичното извикване на ИИ — точно това сравнява таблицата по-долу. Нито една от тези 4 стратегии не се използва реално в продукция днес.",
    flowPersistTitle = "Запазено",
    flowPersistSubtitle = "Реалният резултат и 4-те симулации се съхраняват",
    flowDashboardTitle = "Табло",
    flowDashboardSubtitle = "Този екран обобщава резултатите по стратегия",
    tableTitle = "Сравнение на възможните стратегии",
    columnMode = "Стратегия",
    columnDocuments = "Документи",
    columnClaudeCalls = "Извиквания на ИИ",
    columnProjectedCost = "Прогнозна цена",
    columnRealCost = "Реална цена",
    columnSavings = "Прогнозни спестявания",
    modeBaseline = "Текуща стратегия",
    modeBaselineDescription = "ИИ се извиква систематично за всеки документ — това реално се използва днес в продукция.",
    modeMinimal = "Лека предварителна обработка",
    modeMinimalDescription = "Малки оптимизации преди изпращане към ИИ, без да се променя решението: ИИ винаги се извиква, същата цена като текущата стратегия.",
    modeTesseractGate = "Локално четене с резервен ИИ",
    modeTesseractGateDescription = "Безплатно локално четене първо оценява качеството на документа; ИИ се извиква само ако това четене се сметне за недостатъчно.",
    modeTesseractOnly = "Само локално четене",
    modeTesseractOnlyDescription = "Никакво извикване на ИИ — само безплатно локално четене, потенциално по-малко надеждно при документи с лошо качество.",
)
